import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BoxStyled } from "../../styledComponents/component";
import Modal from "./../../common/components/newModal";
import { actionTypes } from "./../../redux/charts-tables-data/select_portfolio";
import ModalInsertPayment from "./modalInsertPayments/index";
import TablesHistory from "./tablesHistory";

let useStyles = makeStyles((theme) => ({
	gridPayment: {},
	gridCard: {
		width: 200,
		// minHeight: 145,
	},
	modal: {
		width: "50%",
		minHeight: 500,
		backgroundColor: "#ffffff",
		zIndex: 100,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 5),
		borderRadius: 5,
	},
	container: {
		width: "97%",
		margin: "auto",
	},
}));

export default function Index() {
	let classes = useStyles();
	const [open, setOpen] = useState(false);

	let dispatch = useDispatch();

	const [state, setState] = useState({ remain: null });

	let reducer = useSelector((state) => state.select_portfolio_reducer);

	useEffect(() => {
		if (reducer?.data?.length !== 0) {
			handleData(reducer.data[0]);
		}
	}, [reducer?.data]);

	useEffect(() => {
		dispatch({ type: actionTypes.selectPortfolioAsync });
	}, []);

	const handleData = (data) => {
		let remain = data?.body?.remain;

		setState((prevState) => ({ ...prevState, remain: remain }));
	};

	return (
		<div>
			<BoxStyled>
				<div className={classes["container"]}>
					<div className={`${classes["gridPayment"]} flex justify-between`}>
						<div>
							<h1 className=" mb-3 mt-2 text-lg text-gray-600 text-md">
								{`لیست درخواست های من ( باشگاه )`}
							</h1>
						</div>
					</div>

					<div>
						<TablesHistory />
					</div>

					<Modal open={open} setOpen={setOpen}>
						<div className={classes["modal"]}>
							<ModalInsertPayment />
						</div>
					</Modal>
				</div>
			</BoxStyled>
			{/* <div className={classes['gridCard']}>
                <Card>
                    <div className="py-6 px-6 relative w-full h-full flex flex-col justify-between items-end">
                        <div className="self-start">
                            موجودی
                        </div>
                        <div className="flex flex-col items-end">
                            <div className="text-base font-normal text-gray-400">
                                تومان
                            </div>
                            <div className="font-medium text-xl">
                              {
                                state.remain ? state.remain : '0'
                              }
                            </div>
                        </div>
                    </div>
                </Card>
            </div> */}
		</div>
	);
}
